module.exports = __webpack_public_path__ + "static/media/key.f891b999.png";